import { FC } from 'react';
import cls from './progress-bar.module.scss';

interface ProgressBarProps {
  score: number;
  progressClass?: string;
  className?: string;
  variant?: 'simple' | 'detailed';
}

export const ProgressBar: FC<ProgressBarProps> = (props: ProgressBarProps) => {
  const { score, progressClass, variant = 'simple' } = props;

  if (variant === 'simple') {
    return (
      <>
        <div
          className={progressClass}
          style={{
            width: `calc(${score}%)`,
            height: '4px',
            borderRadius: '4px 0 0 4px',
          }}
        />
        <div
          style={{
            width: `calc(${100 - score}%)`,
            height: '4px',
            backgroundColor: '#C5C6D0',
            borderRadius: '0px 4px 4px 0px',
          }}
        />
      </>
    );
  }

  return (
    <div className={cls.progressWrapper}>
      <div
        className={`${cls.progressFilled} ${progressClass || ''}`}
        style={{ width: `${score}%` }}
      />
      <div className={cls.progressEmpty}>
        {score < 100 && (
          <div className={`${cls.progressDot} ${progressClass || ''}`} />
        )}
      </div>
    </div>
  );
};
